import ApplicationController from './application_controller'

export default class extends ApplicationController {

	connect() {
		this.enable()
	}

	disconnect() {
		if (this.disabledAttributeObserver) this.disabledAttributeObserver.disconnect()
	}

	disable() {
		this.element.setAttribute('disabled', '')
		this.element.querySelector('.show-when-enabled').classList.add('d-none')
		this.element.querySelector('.show-when-disabled').classList.remove('d-none')
		this.createAttributeObserver()
	}

	enable() {
		this.element.removeAttribute('disabled')
		this.element.querySelector('.show-when-enabled').classList.remove('d-none')
		this.element.querySelector('.show-when-disabled').classList.add('d-none')
		if (this.disabledAttributeObserver) this.disabledAttributeObserver.disconnect()
	}

	createAttributeObserver() {
		const callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
					if (!this.element.disabled) {
						this.element.querySelector('.show-when-enabled').classList.remove('d-none')
						this.element.querySelector('.show-when-disabled').classList.add('d-none')
					}
				}
			}
		}

		this.disabledAttributeObserver = new MutationObserver(callback.bind(this))

		this.disabledAttributeObserver.observe(this.element, { attributes: true, childList: false, subtree: false })
	}
}
